import {Injector, Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Query} from '../../models/query/query';
import {Specifikacija} from '../../models/nabavke/specifikacija';
import {AppModulePath} from '../../models/app-module-path';
import {WebMethodResult} from '../../models/web-method-result';
import {Item} from 'app/models/lookups/item';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class SpecifikacijaService extends BaseService {
  private byIdUrl = '/api/specifikacija/byId/{id}';
  private listUrl = '/api/specifikacija/list';
  private saveUrl = '/api/specifikacija/save';
  private deleteUrl = '/api/specifikacija/delete/';
  private findByItemNameUrl = '/api/specifikacija/find_by_name';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<Specifikacija[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Specifikacija[]>(url, AppModulePath.KRATAK_OPIS).pipe(
      map(res => res.map(obj => new Specifikacija(obj))),
      catchError(this.handleError));
  }

  save(specifikacija: Specifikacija): Observable<Specifikacija> {
    return this.post<Specifikacija>(this.saveUrl, AppModulePath.KRATAK_OPIS, specifikacija).pipe(
      map(res => new Specifikacija(res)),
      catchError(this.handleError));
  }

  delete(id: number): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.KRATAK_OPIS).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  findByItemName(item: Item): Observable<Specifikacija> {
    return this.post(this.findByItemNameUrl, AppModulePath.KRATAK_OPIS, item).pipe(
      map(res => {
        // console.log(res);
        return new Specifikacija(res);
      }),
      catchError(this.handleError));
  }

  byId(specifikacijaId: number): Observable<Specifikacija> {
    return this.get<Specifikacija>(this.byIdUrl.replace('{id}', specifikacijaId.toString()),
                                   AppModulePath.KRATAK_OPIS).pipe(
      map(res => {
        // console.log(res);
        return new Specifikacija(res);
      }),
      catchError(this.handleError));
  }
}
